const planViewScroll = (() => {
  const pagePlan = (document.getElementById("pagePlan") != null);
  if (pagePlan) {



    let secView = document.querySelector('#jsSecView');
    let scrolls = secView.querySelectorAll('.js-scroll');


    function mousedragscrollable(element) {
      let target;
      // const elms = document.querySelectorAll(element);
      const elms = element;
      for (let i = 0; i < elms.length; i++) {
        elms[i].addEventListener('mousedown', function (evt) {
          evt.preventDefault();
          target = elms[i];
          target.dataset.down = 'true';
          target.dataset.move = 'false';
          target.dataset.x = evt.clientX;
          target.dataset.y = evt.clientY;
          target.dataset.scrollleft = target.scrollLeft;
          target.dataset.scrolltop = target.scrollTop;
          evt.stopPropagation();
        });
        elms[i].addEventListener('click', function (evt) {
          if (elms[i].detaset != null && elms[i].detaset.move == 'true') evt.stopPropagation();
        });
      }
      document.addEventListener('mousemove', function (evt) {
        if (target != null && target.dataset.down == 'true') {
          evt.preventDefault();
          let move_x = parseInt(target.dataset.x) - evt.clientX;
          let move_y = parseInt(target.dataset.y) - evt.clientY;
          if (move_x !== 0 || move_y !== 0) {
            target.dataset.move = 'true';
          } else {
            return;
          }
          target.scrollLeft = parseInt(target.dataset.scrollleft) + move_x;
          // target.scrollTop = parseInt(target.dataset.scrolltop) + move_y;
          evt.stopPropagation();
        }
      });
      document.addEventListener('mouseup', function (evt) {
        if (target != null && target.dataset.down == 'true') {
          target.dataset.down = 'false';
          evt.stopPropagation();
        }
      });
    }

    window.addEventListener('DOMContentLoaded', function () {
      mousedragscrollable(scrolls);
    });



    let viewWrap = secView.querySelector('.js-view-wrap');
    let iconBox = secView.querySelector('.js-scroll-hint-icon-box');

    viewWrap.addEventListener('mouseover', (event) => {
      iconBox.style.display = 'none'
    });

    viewWrap.addEventListener('touchstart', function () {
      iconBox.style.display = 'none'
    });



  }
})()
export default planViewScroll;